import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { cn } from '@v2/shared/lib/utils';

type Props = {
  href: string;
  title: string;
  icon?: IconLookup;
};

export default function AccountLink({ href, title, icon }: Props) {
  return (
    <a
      href={href}
      key={title}
      className={cn(
        'group cursor-pointer w-full h-16 text-lg flex items-center justify-between relative text-slate-900',
        'bg-slate-100 hover:bg-slate-200 active:bg-slate-300 active:text-black rounded-md p-3',
        'inline-flex'
      )}
    >
      <div className="flex flex-col w-full">
        <div className="mr-3">
          <FontAwesomeIcon icon={icon ? icon : faInfoCircle} className="text-sm" fixedWidth />
        </div>
        <div className="flex-grow">
          <div className="text-[14.5px] leading-tight font-semibold text-slate-900">{title}</div>
        </div>
      </div>
      <FontAwesomeIcon
        icon={faAngleRight}
        className="text-slate-400 mr-1 group-hover:text-slate-900 group-active:text-slate-900"
      />
    </a>
  );
}
